module.exports = __webpack_public_path__ + "media/images/viewer_screen_sample-d15b6d18681ed88d4d5ef484e243c02d.png";